// removed by extract-text-webpack-plugin
module.exports = {"container":"_2OUeOFgio1TJE3mxp5pPXx"};